import { loadArtFonts } from "../../lib/schedule-art/art-fonts";
import { downloadBlob } from "../../lib/download-blob";
import Konva from "konva";
import { loadPlatformImages } from "../../lib/schedule-art/platform-images";
import type { CustomArt } from "../../stores/custom-art-store";
import { loadArtImage, scheduleArtSources } from "../../lib/schedule-art/art-assets";
import { renderArtText, type ArtData } from "./art-text";
import { ART_HEIGHT, ART_WIDTH, createArtExportStage } from "../../lib/schedule-art/art-canvas";

export async function createArtLayer(sources: string[]) {
  const images = await Promise.all(sources.map(loadArtImage));
  const layer = new Konva.Layer({ listening: false });
  images.forEach(image => layer.add(new Konva.Image({
    image, x: 0, y: 0, width: ART_WIDTH, height: ART_HEIGHT,
  })));
  return layer;
}

export async function exportScheduleArt(data: ArtData, filename: string, layers: CustomArt[], offlineLabel: string) {
  const [layer] = await Promise.all([
    createArtLayer(scheduleArtSources(data.preset, data.week, data.slots)),
    loadArtFonts(data.preset.metadata),
    loadPlatformImages(),
  ]);
  const stage = createArtExportStage();
  try {
    const background = new Konva.Layer({ listening: false });
    background.add(new Konva.Rect({
      x: 0, y: 0, width: ART_WIDTH, height: ART_HEIGHT, fill: "white",
    }));
    const visibleLayers = layers.filter(layer => layer.visible);
    visibleLayers.forEach(art => background.add(new Konva.Image({ image: art.image, ...art.transform })));
    stage.add(background);
    stage.add(layer);
    const textGroup = new Konva.Group({ listening: false });
    layer.add(textGroup);
    renderArtText(textGroup, data, offlineLabel);
    const canvas = stage.toCanvas({ pixelRatio: 1 });
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(value => value?.type === "image/webp"
        ? resolve(value) : reject(new Error("WebP export failed")), "image/webp", 1);
    });
    downloadBlob(blob, filename);
  } finally {
    stage.destroy();
  }
}
